import React from 'react';
import { useTranslation } from 'react-i18next';
import { User, Paperclip } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import HCLogo from './HCLogo';

const Message = ({ message }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const isUser = message.role === 'user';

  return (
    <div className={`msg-enter group px-4 lg:px-6 py-5 ${isUser ? 'bg-white' : 'bg-slate-50/60'}`}>
      <div className="max-w-3xl mx-auto flex gap-4">
        <div className="flex-shrink-0">
          {isUser ? (
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 text-white flex items-center justify-center text-xs font-semibold">
              {user?.initials || <User className="w-4 h-4" />}
            </div>
          ) : (
            <HCLogo size="md" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-sm font-semibold text-slate-900">
              {isUser ? (user?.name || t('common.profile')) : 'HC Assistant'}
            </span>
          </div>
          {message.attachments && message.attachments.length > 0 && (
            <div className="mb-2 flex flex-wrap gap-2">
              {message.attachments.map((att, i) => (
                <div key={`${att.name || 'att'}-${i}`} className="inline-flex items-center gap-1.5 text-xs bg-blue-50 border border-blue-100 text-blue-900 rounded-md px-2 py-1">
                  <Paperclip className="w-3 h-3" />
                  <span className="truncate max-w-[200px]">{att.name}</span>
                </div>
              ))}
            </div>
          )}
          <div className="text-[15px] text-slate-800 leading-relaxed whitespace-pre-wrap prose-ai">
            {message.content}
          </div>
        </div>
      </div>
    </div>
  );
};

const TypingIndicator = () => {
  const { t } = useTranslation();
  return (
    <div className="px-4 lg:px-6 py-5 bg-slate-50/60">
      <div className="max-w-3xl mx-auto flex gap-4">
        <HCLogo size="md" />
        <div className="flex-1">
          <div className="text-sm font-semibold text-slate-900 mb-2">HC Assistant · <span className="text-slate-500 font-normal">{t('chat.thinking')}</span></div>
          <div className="flex items-center gap-1.5">
            <span className="typing-dot w-2 h-2 rounded-full bg-blue-600" />
            <span className="typing-dot w-2 h-2 rounded-full bg-blue-600" />
            <span className="typing-dot w-2 h-2 rounded-full bg-blue-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

const ChatMessages = ({ messages, loading, endRef }) => {
  return (
    <div className="pb-6">
      {messages.map((m, i) => <Message key={m.id || `${m.role}-${m.createdAt || i}`} message={m} />)}
      {loading && <TypingIndicator />}
      <div ref={endRef} />
    </div>
  );
};

export default ChatMessages;
